import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WellnessComponent } from './wellness.component';
import { HealthMeasureComponent } from './health-measure/health-measure.component';
import { LabResultsComponent } from './lab-results/lab-results.component';
import { LifestyleComponent } from './lifestyle/lifestyle.component';

const wellnessRoutes: Routes = [
	{
		path: '',
		component: WellnessComponent,
		data: {
			title: 'Wellness',
		},
		children: [
			{
				path: '',
				component: HealthMeasureComponent,
				data: {
					title: 'Wellness Summary',
				},
			},
			{
				path: 'summary/health/lab-results',
				component: LabResultsComponent,
				data: {
					title: 'Lab Results',
				},
			},
			{
				path: 'summary/health/lifestyle',
				component: LifestyleComponent,
				data: {
					title: 'Lifestyle',
				},
			},
		],
	},
	{
		path: 'summary',
		redirectTo: 'summary/health/measure',
		pathMatch: 'full',
	},
];

@NgModule({
	imports: [RouterModule.forChild(wellnessRoutes)],
	exports: [RouterModule],
})
export class WellnessRoutingModule {}
